<template>
  <div class="header">
    <div class="header-top large-header">
      <div>
        <img @click="goPage('home');resetTab()" :src="`${$g.imgPrefix}/img/header/logo-header.png`" class="header-logo"/>
        <div :class="[userInfo?'login-wid':'non-login-wid','header-tab']">
          <el-tabs v-model="activeTab" @tab-click="tabClick">
            <el-tab-pane
                v-for="(item,i) in tabList"
                :key="i"
                :label="item.text"
                :name="item.activeName"/>
          </el-tabs>
        </div>
      </div>
      <div class="header-operation">
        <!-- 语言-->
        <el-button type="primary" class="green-btn lang-btn" @click="toSetLang">
          <img class="earth" :src="`${$g.imgPrefix}/img/header/earth.svg`">
          <span class="lang-btn-text">{{ filterObj($g.languageList, 'code', language).name }}</span>
        </el-button>
        <!-- 未登录-->
        <div v-if="isEmpty(userInfo)" class="header-login large-header-login">
          <!-- 注册-->
<!--          <span class="mr-6" @click="goPage('login')">{{$t('login.register')}}</span>-->
          <!-- 登录-->
          <el-button type="primary" class="green-btn" @click="goPage('login')">{{$t('login.login')}}</el-button>
        </div>
        <!-- 已登录-->
        <div v-else class="header-user">
          <el-popover
              v-model="showPopover"
              popper-class="header-popper"
              placement="bottom-end"
              width="240"
              trigger="click">
            <div class="user" @click="goPage('userinfo');closePopper()">
              <div class="w-100">
                <div class="user-email">{{ userInfo.email }}</div>
                <!-- 个人信息-->
                <div class="user-detail">{{$t('header.personaldetails')}}</div>
              </div>
              <img class="user-arrow" :src="`${$g.imgPrefix}/img/header/arrow-right.svg`">
            </div>
            <div class="content">
              <el-divider class="pl-4 pr-4"></el-divider>
              <div :class="[{'active':slideActiveItem==hItem.activeName},'content-item']"
                   v-for="(hItem,hIndex) in headerPopperList"
                   :key="hIndex"
                   @click="setSlideActiveItem(hItem.activeName)">
                <img :src="hItem.img">
                <div class="content-text">{{ hItem.text }}</div>
              </div>
              <!--                <div class="content-item">-->
              <!--                  <img :src="`${$g.imgPrefix}/img/header/language.webp`">-->
              <!--                  <div class="content-text">选择语言</div>-->
              <!--                </div>-->
              <el-divider class="pl-4 pr-4"></el-divider>
              <div class="content-item" @click="logOut">
                <img :src="`${$g.imgPrefix}/img/header/logout.webp`">
                <!-- 登出-->
                <div class="content-text">{{$t('userinfo.signout')}}</div>
              </div>
            </div>
            <img :src="iconImg" slot="reference">
          </el-popover>
        </div>
      </div>
<!--      <div class="header-r large-header-r">-->
<!--        -->
<!--      </div>-->
    </div>
    <logOut ref="logOut" v-if="showLogOut" @logOut="refreshPage"/>
    <setLang ref="setLang" v-if="showSetLang" @refresh="refreshPage"/>
  </div>
</template>

<script>
import {
  isEmpty,
  filterObjGetIndex,
  filterObj
} from "@/util/util"
import logOut from "../logOut";
import setLang from "./setLang"
import PubSub from "pubsub-js";

export default {
  name: "headerTemp",
  components: {
    logOut,
    setLang
  },
  inject: ['reload'],
  data() {
    return {
      activeTab: this.$g.pcActiveTab,
      showPopover: false,
      iconImg: `${this.$g.imgPrefix}/img/home/avatar.svg`,
          //require("@/assets/img/home/avatar.svg"),
      currentIndex: 0,
      slideActiveItem: this.$g.pcActiveTab,
      tabList: [
        {
          //首页
          activeName: 'home',
          text: this.$t('map.home')

        },
        {
          //联盟计划
          activeName: 'friends',
          text: this.$t('map.affiliateprogram')

        },
        {
          //售后支持
          activeName: 'aftersales',
          text: this.$t('map.aftersales')
        },
        {
          //订阅
          activeName: 'subscribe',
          text: this.$t('map.subscribe')
        },
        {
          //兑换码
          activeName: 'excode',
          text: this.$t('excode.redemptioncode')
        },
        {
          //shareAI
          activeName: 'shareAI',
          text: 'AI'
        }
      ],
      headerPopperList: [
        {
          //我的订阅
          activeName: 'subscribe',
          img: `${this.$g.imgPrefix}/img/header/subscription.webp`,
          text: this.$t('footer.subscribe')
        },
        {
          //售后支持
          activeName: 'aftersales',
          img: `${this.$g.imgPrefix}/img/header/support.webp`,
          text: this.$t('map.aftersales')
        },
        // {
        //   //帮助中心
        //   activeName: 'help',
        //   img: `${this.$g.imgPrefix}/img/header/help.webp`,
        //   text: this.$t('map.helpcenter')
        // },
        {
          //订单
          activeName: 'order',
          img: `${this.$g.imgPrefix}/img/header/history.webp`,
          text: this.$t('map.order')
        },
        {
          //联盟计划
          activeName: 'friends',
          img: `${this.$g.imgPrefix}/img/header/affiliate.webp`,
          text: this.$t('map.affiliateprogram')
        }
      ],
      defaultIcon: `${this.$g.imgPrefix}/img/header/Group1000005849@2x.webp`,
      showLogOut: false,
      showSetLang: false,
      language: '',
      setLangID: null,
      setTabActiveID: null
    }
  },
  computed: {
    userInfo() {
      let info = this.$cookies.get("userInfo");
      if (info) {
        info = JSON.parse(this.$cookies.get("userInfo"));
      } else {
        info = ''
      }
      return info;
    }
  },
  watch:{
    '$route.path':{
      handler(newVal){
        let pageName = newVal.substr(newVal.lastIndexOf('/')+1)
        this.activeTab = pageName
        this.slideActiveItem = pageName
      },
      immediate:true
    }
  },
  methods: {
    filterObj,
    isEmpty,
    closePopper() {
      this.showPopover = false;
    },
    toSetLang() {
      this.$g.pcActiveTab = this.activeTab;
      this.showSetLang = true;
      this.$nextTick(() => {
        this.$refs['setLang'].init();
      })
    },
    refreshPage() {
      this.reload();
    },
    logOut() {
      this.showLogOut = true;
      this.$nextTick(() => {
        this.$refs['logOut'].init();
      })
    },
    setSlideActiveItem(activeName) {
      this.showPopover = true;
      this.slideActiveItem = activeName;
      this.activeTab = activeName;
      this.currentIndex = filterObjGetIndex(this.tabList, 'activeName', activeName);
      //有一种情况是：popper下拉中有的，在tab里没有，那就要清空
      if(this.isEmpty(this.currentIndex)){
        this.currentIndex = '';
        this.$g.pcActiveTab = '';
        this.slideActiveItem = '';
        this.activeTab = '';
      }

      this.goPage(activeName);
      this.showPopover = false;
    },
    tabClick() {
      if(this.isEmpty(this.userInfo)){
        this.$router.push({
          name: 'login'
        })
        return
      }
      this.currentIndex = filterObjGetIndex(this.tabList, 'activeName', this.activeTab);
      this.slideActiveItem = this.activeTab;
      this.goPage(this.activeTab);
    },
    goPage(page) {
      //个人资料
      if(page==='userinfo'){
        this.currentIndex = '';
        this.$g.pcActiveTab = '';
        this.activeTab = '';
        this.slideActiveItem = '';
      }
      this.$router.push({
        name: page
      })
    },
    resetTab() {
      this.currentIndex = 0;
      this.$g.pcActiveTab = 'home';
      this.activeTab = 'home';
      //this.slideActiveItem = 'home';
    }
  },
  mounted() {
    this.language = localStorage.lang;
    this.$g.languageCode = localStorage.lang;
    this.setLangID = PubSub.subscribe('changeLanguage', (message, activeName) => {
      this.language = activeName;
      this.$g.languageCode = activeName;
    });
    this.setTabActiveID = PubSub.subscribe('setTabActive', (message, activeName) => {
      this.setSlideActiveItem(activeName);
      this.activeTab = activeName;
      this.tabClick();
    });
  },
  beforeDestroy() {
    PubSub.unsubscribe(this.setLangID);
    PubSub.unsubscribe(this.setTabActiveID);
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/header.scss";
</style>
<style lang="scss">
.header-popper.el-popover {
  padding: 24px 0;

  .popper__arrow {
    display: none;
  }

}
</style>
